import { Divider, Modal } from "antd";
import axios from "axios";
import "./style.css";

import { useEffect, useState } from "react";
import { number_3_3 } from "../../../utilities";

import { api } from "../../../api/url";
import Button from "../../Button";

const VisitDetailComponent = (props) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();

  const GetDetailInfo = async () => {
    setLoading(true);
    axios({
      method: "get",
      url: api + "appointment/user/getappointmentdetail/" + props.curId,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((res) => {
        setData(res.data.data);
        setLoading(false);
      })
      .catch((err) => {
        console.log("err", err);
        setLoading(false);
      });
  };

  useEffect(() => {
    GetDetailInfo();
  }, []);

  return (
    <Modal
      open={props.open}
      onCancel={props.setClose}
      footer={null}
      // width={"35%"}
      style={{
        top: 40,
      }}
    >
      <div className="visit-modal-confirm">
        <h4>جزيیات پذیرش</h4>
        <div className="visit-modal-confirm-content">
          <div className="row">
            <div className="col-lg-6 col-6 ">نام‌و‌نام‌خانوادگی:</div>
            <div className="col-lg-6 col-6 visit-modal-left">
              {data?.patientFullName}
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6 col-6 ">شماره‌تماس:</div>
            <div className="col-lg-6 col-6 visit-modal-left">
              {localStorage.getItem("cellphone")}
            </div>
          </div>

          <Divider />
          <div className="row">
            <div className="col-lg-6  col-6"> نام‌پزشک: </div>
            <div className="col-lg-6  col-6 visit-modal-left">
              {data?.attenderFullName}
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6  col-6"> تخصص:</div>
            <div className="col-lg-6  col-6 visit-modal-left">
              {data?.specialtyName}
            </div>
          </div>

          <div className="row">
            <div className="col-lg-6  col-6"> شماره تماس:</div>
            <div className="col-lg-6  col-6 visit-modal-left">
              {data?.phoneList?.map((item, index) => (
                <>
                  {index / 2 !== 0 ? "-" : null}
                  <a>{item.phoneNo}</a>
                </>
              ))}
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6  col-6"> مرکز:</div>
            <div className="col-lg-6  col-6 visit-modal-left">
              {data?.companyName}
            </div>
          </div>

          <div className="row">
            <div className="col-lg-6  col-6 "> آدرس:</div>
            <div className="col-lg-6  col-6 visit-modal-left">
              {data?.branchName}
            </div>
          </div>

          <Divider />
          <div className="row">
            <div className="col-lg-6  col-6">وضعیت :</div>
            <div className="col-lg-6 col-6 visit-modal-left">
              {data?.actionName}
            </div>
          </div>

          <Divider />

          <div className="row">
            <div className="col-lg-6 col-6 ">
              {" "}
              تاریخ: {data?.reserveDatePersian}
            </div>
            <div className="col-lg-6 col-6 visit-modal-left">
              ساعت: {data?.reserveTime}
            </div>
          </div>
          <Divider />
          <div className="row">
            <div className="col-lg-6  col-6">مبلغ پرداختی:</div>
            <div className="col-lg-6 col-6 visit-modal-left">
              {number_3_3(String(data?.admissionAmount))} ریال
            </div>
          </div>

          {/* {props.visitInfo.cashAmountList.map((item) => (
            <div className="row">
              <div className="col-lg-6  col-6">مبلغ قابل پرداخت:</div>
              <div className="col-lg-6 col-6 visit-modal-left">
                {number_3_3(item.price)} ریال
              </div>
            </div>
          ))} */}
        </div>

        <Button
          isSubmitting={loading}
          onClick={() => props.setClose()}
          className="modal-phonenumber-container-button"
        >
          بستن
        </Button>
      </div>
    </Modal>
  );
};

export default VisitDetailComponent;
